<template>
	<a-row :gutter="[12, 12]">
		<SettingTitle />
		<a-col :span="8">
			<div :class="$style.dialogs">
				<a
					href="#"
					:class="[$style.item, current === 'group' ? $style.current : '']"
					class="d-flex flex-nowrap align-items-center"
					v-on:click.stop.prevent="changeDialog('group')"
				>
					<div
						class="air__utils__avatar air__utils__avatar--size46 mr-3 flex-shrink-0"
					>
						<a-icon type="block" class="font-size-40" />
					</div>
					<div :class="$style.info" class="flex-grow-1">
						<div class="text-dark font-size-18 font-weight-bold text-truncate">
							Groups
						</div>
					</div>
					<div
						v-if="true"
						:class="$style.unread"
						class="flex-shrink-0 align-self-start"
					>
						<div class="badge badge-success">2</div>
					</div>
				</a>
				<a
					href="#"
					:class="[$style.item, current === 'category' ? $style.current : '']"
					class="d-flex flex-nowrap align-items-center"
					v-on:click.stop.prevent="changeDialog('category')"
				>
					<div
						class="air__utils__avatar air__utils__avatar--size46 mr-3 flex-shrink-0"
					>
						<a-icon type="appstore" class="font-size-40" />
					</div>
					<div :class="$style.info" class="flex-grow-1">
						<div class="text-dark font-size-18 font-weight-bold text-truncate">
							Categories
						</div>
					</div>
					<div
						v-if="true"
						:class="$style.unread"
						class="flex-shrink-0 align-self-start"
					>
						<div class="badge badge-success">2</div>
					</div>
				</a>
			</div>
		</a-col>
		<a-col :span="16">
			<SettingGroup v-if="current === 'group'" />
			<SettingCategory v-if="current === 'category'" />
		</a-col>
	</a-row>
</template>

<script>
import SettingGroup from '@/components/widgets/Setting/Group'
import SettingCategory from '@/components/widgets/Setting/Category'
import SettingTitle from '@/components/widgets/Setting/Title'

export default {
	name: 'Settings',
	components: {
		SettingGroup,
		SettingTitle,
		SettingCategory,
	},
	data: function() {
		return {
			current: 'group',
		}
	},
	created() {},
	methods: {
		changeDialog(option) {
			this.current = option
		},
	},
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
